import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../utils/itemValidation';

import * as locations from '../../../constants/dropdown';

import * as commonActionCreators from '../../../actions/common';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, usersActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class ContactNoItem extends React.Component {

  constructor(props) {
    super(props);

    const firstEntry = [{display: 'Location*', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntry.concat(locations.locations).concat(finalEntry);

    this.state = {
      open: this.props.common.contactNoItemOpen,
      closing: false,
      inputName: '',
      inputEmail: '',
      inputPhone: '',
      inputCitystate: '',
      inputMessage: '',
      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorCitystate: null,
      errorMessage: null,

      locations: newArray,
    };
  }

  getContactNoItemClass() {
    if(this.state.closing) {
      return 'ContactNoItem closing';
    } else {
      return this.props.common.contactNoItemOpen ? 'ContactNoItem open' : 'ContactNoItem closed';
    }
  }

  closeContactNoItem() {
    this.setState({ closing: true });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      }, () => {
        this.props.commonCloseNoItemContact();
      });
    }, 500)
  }

  catchClick(evt) {
    evt.stopPropagation();
  }

  changeName(evt) {
    this.setState({ inputName: evt.target.value }, () => {
      if(this.state.errorName && !nameValidation(this.state.inputName)) {
        this.setState({ errorName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value }, () => {
      if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
        this.setState({ errorEmail: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ inputPhone: evt.target.value }, () => {
      if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
        this.setState({ errorPhone: null });
      }
    });
  }

  changeCitystate(evt) {
    this.setState({inputCitystate: evt.target.value}, () => {
      if(this.state.errorCitystate && !nameValidation(this.state.inputCitystate)) {
        this.setState({errorCitystate: false});
      }
    });
  }

  changeMessage(evt) {
    this.setState({ inputMessage: evt.target.value }, () => {
      if(this.state.errorMessage && !messageTextValidation(this.state.inputMessage)) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let messageError = messageTextValidation(this.state.inputMessage);
    
    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }
    let citystateError = null;
    if(this.state.inputCitystate) {
      citystateError = nameValidation(this.state.inputCitystate);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       citystateError === null &&
       messageError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorCitystate: citystateError,
      errorMessage: messageError
    });

    return !hasErrors;
  }

  submitContactNoItemRequest() {
    if(this.validateAll()) {

      let contactData = {
        full_name: this.state.inputName,
        email: this.state.inputEmail,
        phone: this.state.inputPhone,
        citystate: this.state.inputCitystate,
        message: this.state.inputMessage,
      }

      this.props.usersContactRequest(contactData);
      this.props.commonContactSent();
      this.props.commonAlert('Thank you! One of our diamond experts will be in touch shortly.', 'Continue');
      this.setState({
        inputName: '',
        inputEmail: '',
        inputPhone: '',
        inputCitystate: '',
        inputMessage: '',
        errorName: null,
        errorEmail: null,
        errorPhone: null,
        errorCitystate: null,
        errorMessage: null,
      });
      this.props.commonCloseNoItemContact();
    }
  }

  render() {
    return <div className={::this.getContactNoItemClass()} onClick={::this.closeContactNoItem}>
      <div className='contactBody' onClick={::this.catchClick}>

        <div className='internalWrapper'>

          <div className='closeContact' onClick={::this.closeContactNoItem}>
            <div className='closeX'>&times;</div>
          </div>
          <div className='formWrapper'>
            <div className='formBody'>
              <div className='formLogo'>
                <img src='/img/svg/DD_white.svg' />
              </div>
              <div className='formTitle'>Luxury in every detail.</div>
              <div className='formRow'>
                <input 
                  className={this.state.errorName ? 'textInput error' : 'textInput'}
                  type='text' 
                  placeholder='FULL NAME &#42;'
                  value={this.state.inputName}
                  onChange={::this.changeName} />
                <input 
                  className={this.state.errorEmail ? 'textInput error' : 'textInput'}
                  type='email' 
                  placeholder='EMAIL ADDRESS &#42;'
                  value={this.state.inputEmail}
                  onChange={::this.changeEmail} />
              </div>
              <div className='formRow'>
                <input 
                  className={this.state.errorPhone ? 'textInput error' : 'textInput'}
                  type='text' 
                  placeholder='TELEPHONE'
                  value={this.state.inputPhone}
                  onChange={::this.changePhone} />
                <input 
                  className={this.state.errorCitystate ? 'textInput error' : 'textInput'}
                  type='text' 
                  placeholder='CITY | STATE'
                  value={this.state.inputCitystate}
                  onChange={::this.changeCitystate}
                  style={{display: 'none'}} />
                <RhinoSelect
                  selectClass={'contactSelect contactPageSelect'}
                  required={true}
                  options={this.state.locations}
                  changeMethod={(evt) => this.changeCitystate(evt)}
                  error={this.state.errorCitystate} />
              </div>
              <div className='formRow'>
                <textarea
                  className={this.state.errorMessage ? 'textTextarea error' : 'textTextarea'}
                  placeholder='HOW CAN WE HELP YOU? &#42;'
                  value={this.state.inputMessage}
                  onChange={::this.changeMessage}>
                </textarea>
              </div>
              <div className='formRow'>
                <div 
                  className={'contactSubmit actionButton'}
                  onClick={::this.submitContactNoItemRequest}>Send</div>
              </div>
            </div>
            <div className='phonePrompt' style={{display: 'none'}}>
              Or call us at: 972-342-6663
            </div>
          </div>

        </div>

      </div>
    </div>
  }
}
export default ContactNoItem;

function mapStateToProps(state) {
  return {
    common: state.common
  };
}

export const ContactNoItemContainer = connect(
  mapStateToProps,
  allActionCreators
)(ContactNoItem);


// WEBPACK FOOTER //
// ./src/components/views/contact/ContactNoItem.jsx